import { useEffect } from "react";

import "./about.css";
import AOS from 'aos';
import 'aos/dist/aos.css';

import dev from "../../assets/image/profile.png";

import { useNavigate } from "react-router-dom";

export default function About() {

  useEffect(() => {
    AOS.init();
  }, [])

  const navigate = useNavigate();

  function goToContact() {
    navigate("/contact");
  }

  function goToCurriculo() {
    window.open(
      `https://drive.google.com/file/d/1Mp8L4q5DvMujvtDagx_HUpeABE1W-2dZ/view?usp=sharing`
    );
  }

  return (
    
      <div className="about" id="about">
        <div className="image" data-aos="fade-down" data-aos-duration="500">
          <img src={dev} alt=""/>
        </div>
        <div id="about--info"  data-aos="fade-up" data-aos-duration="500">
          <p className="tag">Quem sou eu</p>
          <p className="tittle">
            Sobre mim <strong>( )</strong>
          </p>
          <p className="info-text">
            Oi! Sou Leandro Salles. Natural de Belo Horizonte, me apaixonei pelo mundo do
            desenvolvimento. Com estudos ainda em evolução, busco sempre novos conhecimentos na área
            e também pela primeira oportunidade de ingressar no mercado.
          </p>
          <button className="primary-button" onClick={goToCurriculo}>
            Download CV
          </button>
          <button className="primary-button" onClick={goToContact}>
            Contato
          </button>
        </div>
      </div>
    
  );
}
